import React, { useContext } from "react";
import { net } from "../../../../database";
import ShowTags from "./ShowTags";
import { StaffContext, UserContext } from "../../../../Context";

/**
 * ChatInput - Input field for chat replies with @ mention support.
 * Replaces MUI TextField with custom styled input.
 *
 * @author opencode + glm-5.1
 * @date 2026-04-21
 * @version 2.0
 */
export default function ChatInput(props) {
  const { message, messages } = props;
  const { staff } = useContext(StaffContext);
  const { user } = useContext(UserContext);
  const [chat, setChat] = React.useState("");
  const [showAt, setShowAt] = React.useState(false);
  const [staffFilter, setStaffFilter] = React.useState("");
  const [selected, setSelected] = React.useState(0);
  const containerRef = React.useRef(null);

  const sendChat = (e) => {
    if (e.key === "Enter" && chat !== "") {
      e.preventDefault();
      net
        .post(`/message/${message._id}/chat`, {
          user: user._id,
          message: chat,
        })
        .then((result) => {
          messages.update(result);
        });
      setChat("");
    } else {
      let words = chat.split(" ");
      let lastWord = words[words.length - 1];

      if (lastWord.length > 0 && lastWord.substring(0, 1) === "@") {
        setStaffFilter(lastWord.replace("@", ""));
        setShowAt(true);
      }
    }
  };

  let st = staff.filter(
    (s) =>
      staffFilter.length > 0 &&
      s.name.toLowerCase().includes(staffFilter.toLowerCase())
  );

  const doTab = (e) => {
    if (e.key === "Tab") {
      e.preventDefault();
      if (st[selected]) {
        net
          .post(`/message/${message._id}/add-user`, {
            newPerson: st[selected]._id,
          })
          .then((res) => addUser(res, st[selected]));
      }
    }
    if (e.key === "ArrowUp") {
      e.preventDefault();
      if (selected > 0) {
        setSelected(selected - 1);
      }
    }
    if (e.key === "ArrowDown") {
      e.preventDefault();
      if (selected < st.length - 1) setSelected(selected + 1);
    }
  };

  const addUser = (res, user) => {
    let position = chat.lastIndexOf("@");
    setShowAt(false);
    setChat(chat.substring(0, position + 1) + user.name);
    messages.set(messages.map((m) => (m._id === res._id ? res : m)));
  };

  return (
    <div className="chat-input-area" ref={containerRef}>
      {showAt && (
        <ShowTags
          messages={messages}
          setMessages={messages.set}
          message={message}
          addUser={addUser}
          selected={selected}
          staff={st}
          containerRef={containerRef}
        />
      )}
      <div className="chat-input-wrapper">
        <input
          type="text"
          className="chat-text-input"
          value={chat}
          onKeyUp={(e) => sendChat(e)}
          onKeyDown={(e) => doTab(e)}
          onChange={(e) => {
            setChat(e.target.value);
            if (!e.target.value.includes("@")) {
              setShowAt(false);
            }
          }}
          placeholder="Start typing or use @ to tag a staff member..."
        />
      </div>
    </div>
  );
}
